module.exports = __webpack_public_path__ + "static/media/ccd2.84a0b7b7.jpg";